import { FlexColumn, FlexRowCenter } from "designSystem/index";
import React, { FunctionComponent } from "react";
import TableChartOptions from "./TableChartOptions";
import TablePrintOptions from "./TablePrintOptions";
import TableViewOptions from "./TableViewOptions";
import DataSheetTableViewOptions from "./DataSheetTableViewOptions";

const DataSheetTableOptionsTab: FunctionComponent = function DataSheetTableOptionsTab() {
	return (
		<FlexRowCenter>
			<FlexColumn 
				data-csi-automation="DataSheetTableOptionsTab"
				width="100%"
			>
				<DataSheetTableViewOptions />
				<TableViewOptions />
				<TableChartOptions />
				<TablePrintOptions />
			</FlexColumn>
		</FlexRowCenter>
	);
};

export = DataSheetTableOptionsTab;